import { render, staticRenderFns } from "./ResultCard.vue?vue&type=template&id=e54a5da2&"
import script from "./ResultCard.vue?vue&type=script&lang=ts&"
export * from "./ResultCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports